import { Reveal, Overline } from "./Reveal";
import { AUDIENCES } from "@/data/content";

export const Audiences = () => (
  <section id="audiences" data-testid="audiences-grid" className="bg-cream-dark py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mb-14 max-w-2xl">
        <Overline>Who I Work With</Overline>
        <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Young adults &amp; professionals ready to close the gap
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">
          I work with people who want to close the gap between who they are and who they're capable of becoming.
        </p>
      </Reveal>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-6">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={(i % 3) * 0.08} className={a.span}>
            <div
              data-testid={`audience-card-${i}`}
              className="group h-full rounded-3xl border border-peach/20 bg-white p-6 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-peach-dark/50 hover:shadow-[0_24px_50px_-24px_rgba(226,121,111,0.5)]"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cream-dark text-peach-dark transition-[background-color,color,transform] duration-500 group-hover:rotate-6 group-hover:bg-peach-dark group-hover:text-cream">
                <a.icon size={20} strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 font-heading text-base font-bold text-ink sm:text-lg">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted">{a.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
